export default __webpack_public_path__ + "static/vector-shape1-82633865bb45a2cd6d98f22357959392.png";